export default "__VITE_ASSET__kjuKm_Nw__"